export default "__VITE_PUBLIC_ASSET__be41690c__"